const icjiaTypography = `
# Heading 1 (#)
## Heading 2 (##)
### Heading 3 (###)
#### Heading 4 (####)
##### Heading 5 (#####)
###### Heading 6 (######)

---

<div style="text-align: center">

#### DEFAULT TABLE HEADING (####)

</div>

| Item     | Value | Qty   |
| :------- | ----: | :---: |
| Computer | $1600 |  5    |
| Phone    | $12   |  12   |
| Pipe     | $1    |  234  |

---

<div style="text-align: center">

#### DEFAULT CHART HEADING (####)

</div>


![Sample Chart](/static/img/sampleChart.png)

---
# Sample article title (#)

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tristique orci a metus scelerisque dapibus a eu enim. Nam ipsum urna, convallis in rutrum a, porta at nulla. Nunc at eros in neque euismod elementum. Curabitur dictum eget nulla non cursus. Suspendisse tempus metus erat, id pharetra ligula bibendum ac. Nunc eleifend consectetur nulla, vel iaculis libero scelerisque ac. Maecenas venenatis rutrum erat, nec volutpat risus efficitur et.

## Sub-heading (##)

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tristique orci a metus scelerisque dapibus a eu enim. Nam ipsum urna, convallis in rutrum a, porta at nulla. Nunc at eros in neque euismod elementum. Curabitur dictum eget nulla non cursus. Suspendisse tempus metus erat, id pharetra ligula bibendum ac. Nunc eleifend consectetur nulla, vel iaculis libero scelerisque ac. Maecenas venenatis rutrum erat, nec volutpat risus efficitur et.

### Sub-sub-heading 1 (###)

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tristique orci a metus scelerisque dapibus a eu enim. Nam ipsum urna, convallis in rutrum a, porta at nulla.

### Sub-sub-heading 2 (###)

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tristique orci a metus scelerisque dapibus a eu enim. Nam ipsum urna, convallis in rutrum a, porta at nulla.

### Sub-sub-heading 3 (###)

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tristique orci a metus scelerisque dapibus a eu enim. Nam ipsum urna, convallis in rutrum a, porta at nulla.

## Sub-heading (##)

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam tristique orci a metus scelerisque dapibus a eu enim. Nam ipsum urna, convallis in rutrum a, porta at nulla. Nunc at eros in neque euismod elementum. Curabitur dictum eget nulla non cursus. Suspendisse tempus metus erat, id pharetra ligula bibendum ac. Nunc eleifend consectetur nulla, vel iaculis libero scelerisque ac. Maecenas venenatis rutrum erat, nec volutpat risus efficitur et.










`
export {icjiaTypography}



// WEBPACK FOOTER //
// ./src/boilerplates/icjiaTypography.js